module.exports = __webpack_public_path__ + "media/V45.ebc687ef.mp4";